import React from 'react';
import GenericCRUDPage from '../../components/GenericCRUDPage';
import { FormField, Input, Textarea, Badge } from '../../components/UI';
import { branchService } from '../../api/services';
import { toJalali } from '../../utils/jalali';

const BranchFormFields = ({ form: { register } }) => (
  <div className="grid grid-cols-2 gap-4">
    <FormField label="Branch Name" required>
      <Input {...register('name', { required: 'Required' })} placeholder="Main Branch" />
    </FormField>
    <FormField label="Branch Code" required>
      <Input {...register('code', { required: 'Required' })} placeholder="MAIN-001" />
    </FormField>
    <FormField label="Phone">
      <Input {...register('phone')} placeholder="+93 700 000 000" />
    </FormField>
    <FormField label="Email">
      <Input type="email" {...register('email')} placeholder="branch@pharmacy.com" />
    </FormField>
    <div className="col-span-2">
      <FormField label="Address">
        <Textarea {...register('address')} rows={2} placeholder="Branch address" />
      </FormField>
    </div>
    <div className="col-span-2 flex items-center gap-2">
      <input type="checkbox" {...register('isHeadquarters')} id="hq" className="rounded" />
      <label htmlFor="hq" className="text-sm text-gray-700 cursor-pointer">This is the Headquarters branch</label>
    </div>
  </div>
);

const columns = [
  { key: 'name', label: 'Branch Name', sortable: true },
  { key: 'code', label: 'Code' },
  { key: 'phone', label: 'Phone' },
  { key: 'email', label: 'Email' },
  { key: 'isHeadquarters', label: 'HQ', render: (v) => v ? <Badge color="blue">HQ</Badge> : '-' },
  { key: 'isActive', label: 'Status', render: (v) => <Badge color={v ? 'green' : 'gray'}>{v ? 'Active' : 'Inactive'}</Badge> },
  { key: 'createdAt', label: 'Created', render: (v) => toJalali(v) },
];

export default function BranchesPage() {
  return (
    <GenericCRUDPage
      title="Branches"
      subtitle="Manage pharmacy branches"
      service={branchService}
      entityName="Branch"
      columns={columns}
      FormFields={BranchFormFields}
      modalSize="lg"
    />
  );
}
